import Vue from 'vue';
import SkySwiper from './sky-swiper';

Vue.component('sky-swiper', SkySwiper);

export default SkySwiper;



// WEBPACK FOOTER //
// ./scripts/sky-swiper/index.js